import { tw } from '~/utils';

export type SearchBoxStyles = {
  base: string;
  box: string;
  input: string;
  clear: string;
  button: string;
};

export type SearchBoxTriggerStyles = {
  base: string;
  box: string;
  input: string;
  button: string;
};

export const searchBoxStyles = tw<SearchBoxStyles>({
  base: 'border-grey-200 text-grey-950 has-[input:focus-visible]:border-grey-950 flex w-full flex-none items-center justify-between rounded-full border',
  box: 'relative flex-auto',
  input:
    '!text-body-m text-grey-950 placeholder:!text-grey-400 w-full appearance-none rounded-l-full border-none pr-4 pl-4 outline-none',
  clear: 'focus-visible:outline-grey-950 absolute top-1/2 right-2 -translate-y-1/2',
  button:
    'group bg-grey-950 hover:disabled:bg-grey-950 hover:!border-grey-950 ring-grey-950 hover:disabled:bg-grey-950 flex items-center justify-center rounded-r-full px-4 py-2 hover:bg-white hover:ring-1 hover:ring-offset-0 hover:disabled:ring-0',
});

export const searchBoxTriggerStyles = tw<SearchBoxTriggerStyles>({
  base: 'border-grey-200 hover:border-grey-950 focus-visible:border-grey-950 flex size-full items-stretch justify-between overflow-hidden rounded-full border focus-visible:outline-solid',
  box: 'text-body-m flex items-center truncate px-4',
  input: 'text-grey-400',
  button: 'bg-grey-950 flex items-center justify-center px-4 py-2',
});
